import { useState, useEffect, useContext } from "react";
import "./Toaster.css";
import { hideToaster } from "../../../context/action/toaster/toaster";
import { GlobalContext } from "../../../context/Provider";
import {
  CloseIcon,
  Icon,
  Message,
  ProgressBar,
  ToastContainer,
  ToastContent,
} from "./localstyle";
import {
  FaCheckCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaTimes,
  FaTimesCircle,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const ToasterV2 = () => {
  const { toasterState, toasterDispatch } = useContext(GlobalContext);
  const [show, setShow] = useState(true);
  const posicion = toasterState.toaster.data?.posicion;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false); // Activa la animación de salida
      setTimeout(() => {
        hideToaster()(toasterDispatch); // Luego desmonta el toaster después de la animación
      }, 500); // Este tiempo debe coincidir con la duración de la animación de salida
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <ToastContainer
          as={motion.div}
          initial={
            typeof posicion === "string" && posicion.includes("down")
              ? { opacity: 0, y: 50 }
              : { opacity: 0, y: -100 }
          }
          animate={{ opacity: 1, y: 0 }}
          exit={
            typeof posicion === "string" && posicion.includes("down")
              ? { opacity: 0, y: 50 }
              : { opacity: 0, y: -100 }
          }
          transition={{ duration: 0.4 }}
          style={
            typeof posicion === "string" &&
            (posicion.includes("left") || posicion.includes("right"))
              ? {}
              : {
                  left: "50%",
                  x: "-50%",
                }
          }
          $posicion={toasterState.toaster.data?.posicion}
          $tipo={toasterState.toaster?.data?.params?.tipo}
        >
          <ToastContent>
            <Icon>
              {toasterState.toaster.data.params.tipo === "success" ? (
                <FaCheckCircle size={22} />
              ) : toasterState.toaster.data.params.tipo === "danger" ? (
                <FaTimesCircle size={22} />
              ) : toasterState.toaster.data.params.tipo === "info" ? (
                <FaInfoCircle size={22} />
              ) : (
                <FaExclamationTriangle size={22} />
              )}
            </Icon>
            <Message>{toasterState.toaster.data?.params?.texto}</Message>
            <CloseIcon onClick={() => hideToaster()(toasterDispatch)}>
              <FaTimes />
            </CloseIcon>
          </ToastContent>
          <ProgressBar />
        </ToastContainer>
      )}
    </AnimatePresence>
  );
};

export default ToasterV2;
